import React from 'react';
import AboutPage from '../components/AboutPage';

const About = () => {
  return <AboutPage lang="en" title="About the course | Full Stack open" />;
};

export default About;
